import AddIcon from '@clearkit/icons/glyphs/AddBlock';
import { CKButton } from '@clearkit/react';
import { Link } from 'react-router-dom';

import paths from '~/lib/paths';
import { readableSingularSegmentType } from '~/lib/segments';

import styles from './styles.style';

function NewAudienceButton({ classes, className, type }) {
  return (
    <CKButton
      variant="bold"
      variantColor="blue"
      as={Link}
      to={paths.segmentNew(type)}
      leftIcon={<AddIcon className={classes.newAudienceButtonIcon} />}
      className={classnames(className, classes.newAudienceButton)}>
      New {readableSingularSegmentType(type)} audience
    </CKButton>
  );
}

NewAudienceButton.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  type: PropTypes.oneOf(['Company', 'Person']).isRequired,
};

export default withStyles(styles)(NewAudienceButton);
